import React, {useEffect, useState} from 'react';
import DropdownMenu from 'eventbrite_design_system/dropdownMenu/DropdownMenu';
import DropLink from 'eventbrite_design_system/dropdownMenu/_internal/DropLink';


export default function DropdownMenuFallback(props) {
    const [isInBrowser, setIsInBrowser] = useState(false);

    useEffect(() => setIsInBrowser(true));

    return (
        isInBrowser ?
            <DropdownMenu
                {...props}
            >
                {props.children}
            </DropdownMenu>
            :
            <DropLink>
                {props.children}
            </DropLink>
    );
}
